module.exports = __webpack_public_path__ + "static/app-00af939b87fba31c9eaf8eb0e963c8ba.png";